import { useNavigate } from "react-router-dom";
import { ProgressBar } from "../index";
import { SmallUpArrow } from "../svg-organizer/SvgOrganizer";

const BalanceCard = ({ cardData }) => {
  const navigate = useNavigate();
  return (
    <>
      <div
        className="card dashboard-wallet-card cursor-pointer"
        onClick={() => navigate("/wallet")}
      >
        <div className="card-body">
          <div className="dashboard-wallet-card-content">
            <div className="dashboard-wallet-main">
              <div className="align-self-center">
                {cardData.flagIcon ? (
                  <img
                    src={cardData.flagIcon}
                    className="rounded-circle"
                    style={{ objectFit: "cover" }}
                    alt={`${cardData.currency} flag`}
                  />
                ) : (
                  <span className="currency-flag-fallback">
                    {cardData.currency}
                  </span>
                )}
              </div>
              <div className="dashboard-wallet-copy">
                <span className="dashboard-wallet-currency-name">
                  {cardData.curenncyName}
                </span>
                <span className="dashboard-wallet-amount">{cardData.amount1}</span>
              </div>
            </div>
            <div className="dashboard-wallet-meta">
              <div className="dashboard-wallet-available">
                <span className="fw-medium">{cardData.amount2}</span>
                <div
                  className="d-flex gap-1 align-items-center fs-6"
                  style={{ color: "#1BBB6B" }}
                >
                  <span>
                    <SmallUpArrow />
                  </span>
                  <span>{cardData.percentage1}</span>
                </div>
              </div>

              <div className="dashboard-wallet-percent">
                <div className="align-self-center">
                  <ProgressBar
                    type="circle"
                    size={18}
                    strokeColor="#0E2C24"
                    strokeWidth={16}
                    percent={cardData.percentage2}
                  />
                </div>

                <span>{cardData.percentage2}%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BalanceCard;
